/**
 * <strong>Purpose:</strong> <br>
 * Provides the ability to display text in multiple lines. Can accept the standard \n separated strings from
 * localization bundles. It escapes HTML and preserves whitespaces.
 * <br><br>
 * <strong>Contract:</strong> <br>
 * <em>Attach-point:</em> textNode <br>
 * The Mixin will add the multiple text nodes for each line of text into the textNode attach-point.
 *
 * @module MW/toolstrip/mixins/property/TextMixin
 *
 * @copyright Copyright 2016 The MathWorks, Inc.
 */
define([
    "dojo/_base/declare"
], function (declare) {

    return declare(null, {

        /**
         * @property  {string} text  Supports any unicode text
         * @instance
         */
        text: "",

        postCreate: function () {
            this.inherited(arguments);
            this.domNode.classList.add("mwTextMixin");
            this._addTextContentClass();

            // When the default value is falsy, the setter will not be triggered during the widget's construction phase
            // We need to call the setter explicitly
            this.set("text", this.get("text"));
        },

        _setTextAttr: function () {
            this.inherited(arguments);

            if (this._started && this._checkAndFixClippedText) {
                // g2037662: Having a fixed width on the column might cause a part of the widget's text to get clipped
                // off when its orientation is Vertical. This function (defined in OrientationMixin.js) checks for such
                // possibility and fixes the clipped text.
                this._checkAndFixClippedText();
            }
        },

        /**
         * This method adds the CSS classes to the appropriate nodes used to render text
         * @private
         */
        _addTextContentClass: function () {
            var textNode = this.textNode || this.domNode;
            textNode.classList.add("mwTextContent");
        },

        /**
         * This method can be overridden in the cases where the text to be displayed in the DOM is differently formatted
         * than the actual text value.
         * @param text - The text to be place dinto the dom
         * @param node - Unused in the default implementation
         * @private
         */
        _getTextForDOM: function (text, node) {
            return text;
        },

        _placeTextInNode: function (text, node) {
            node = node || this.textNode;
            this._updateDataTextContent(text, node);
        },
        
        _updateDataTextContent: function (text, node, force) {
            (node || this.textNode || this.domNode).setAttribute("data-text-content", force ? text : this._getTextForDOM(text, node));
        }

    });

});
